import axios from "axios";

export const createResumeExpociencias22 = async(props) => {
    const url = process.env.REACT_APP_BASE_URL + "/api/pdf/createResumeExpociencias22";

    const values = {
        title: props.title,
        fileName: props.fileName, 
        category: props.category, 
        area: props.area,
        content: props.content
    };

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("pdf creado...");
        }
    })

    return result;
};
